import CompletableChecklist from "@coworker/apprestructured/src/task-management/components/CompletableChecklist/CompletableChecklist";
import ChecklistItem from "@coworker/apprestructured/src/task-management/types/ChecklistItem";
import { ViewerFragmentCommonProps } from "@coworker/apprestructured/src/task-management/components/TaskViewerSheet/viewer-fragments/ViewerFragment";
import {
  getByPath,
  setByPath,
} from "@coworker/apprestructured/src/shared/helpers/object.helper";
import { useCallback } from "react";
import { isLoading } from "@coworker/apprestructured/src/task-management/loading";

export type CompletableChecklistViewerFragmentConfigProps = {
  field: string;
  label: string;
};

type CompletableChecklistViewerFragmentProps = {
  configProps: CompletableChecklistViewerFragmentConfigProps;
  commonProps: ViewerFragmentCommonProps;
};

function CompletableChecklistViewerFragment({
  configProps,
  commonProps,
}: CompletableChecklistViewerFragmentProps) {
  const { field, label } = configProps;
  const { blockInput, task, onTaskChange } = commonProps;
  const items = getByPath<ChecklistItem[]>(task, field);
  const handleItemsChange = useCallback(
    (newItems: ChecklistItem[]) => {
      onTaskChange(setByPath(field, newItems));
    },
    [field, onTaskChange]
  );

  if (isLoading(items)) {
    return null;
  }

  return (
    <CompletableChecklist
      items={items}
      onItemsChange={handleItemsChange}
      label={label}
      disabled={blockInput}
    />
  );
}

export default CompletableChecklistViewerFragment;
